// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__YeBwl","modalContent":"style_modalContent__0SRTB"};